import { render, staticRenderFns } from "./Drama.vue?vue&type=template&id=0602932e&scoped=true"
import script from "./Drama.vue?vue&type=script&lang=js"
export * from "./Drama.vue?vue&type=script&lang=js"
import style0 from "./Drama.vue?vue&type=style&index=0&id=0602932e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0602932e",
  null
  
)

export default component.exports